<template>
  <div class="base-timer">
    <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          :class="remainingPathColor"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <span class="base-timer__label">{{ formattedTimeLeft }}</span>


    <div class="mt-3 mb-6 block w-full text-center">
     <span @click="setTimer()" 
     class="text-purple-600 font-semibold text-xs cursor-pointer  hover:text-purple-300">Set Timer <i class="fas fa-chevron-right pt-4 pl-2"></i></span>

     <timepicker :value="timeLimit" :layout="'time'" @countChange="updateTimer" v-show="settingTimerInView"></timepicker>
    </div>

    <div class="w-full mx-auto mt-4 grid grid-cols-3 gap-3">
       <button @click="startTimer()"  class="button-purple w-full">Start</button>
        <button @click="stop()"  class="button-purple w-full">Stop</button>
         <button @click="pause()"  class="button-purple w-full">Pause</button>
    </div>


       

  </div>
</template>

<script>
const timepicker = () => import('@/components/helpers/DoublePicker.vue')

const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

const TIME_LIMIT = 30;

export default {
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      timeLimit: TIME_LIMIT,
      settingTimerInView: false
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${minutes}:${seconds}`;
    },

    timeLeft() {
      return this.timeLimit - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.timeLimit;
      return rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      }
    }
  },

  mounted() {
   
  },

  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
    },
    stop() {
      this.onTimesUp()
      this.timePassed = 0
      this.timerInterval = null

    },
    pause() {
      this.onTimesUp()
    },
    startTimer() {
      this.settingTimerInView = false
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    setTimer() {
      this.settingTimerInView = !this.settingTimerInView
    },
    updateTimer(value) {
      this.timeLimit = value
    }
  },
  components: {
        timepicker,
  }
};
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 100%;
  height: 240px;
  max-width: 240px;

  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 7px;
    stroke: #F2F2F4;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      color: #927cf8;
    }

    &.orange {
      color: orange;
    }

    &.red {
      color: red;
    }
  }

  &__label {
    position: absolute;
    width: 100%;
    max-width: 240px;
    height: 90%;
    max-height:240px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
  }
}
</style>
